export function getAuthToken() {
  const cookies = document.cookie.split(";");
  const tokenCookie = cookies.find((cookie) => cookie.trim().startsWith("token="));

  if (tokenCookie) {
    return tokenCookie.split("=")[1];
  }

  return window.localStorage.getItem("token");
}

export function persistAuthToken(token) {
  if (!token) {
    return;
  }

  window.localStorage.setItem("token", token);

  const isLocalhost = ["localhost", "127.0.0.1"].includes(window.location.hostname);
  const sameSite = isLocalhost ? "Lax" : "None";
  const secure = isLocalhost ? "" : "; Secure";

  document.cookie = `token=${token}; Path=/; SameSite=${sameSite}${secure}`;
}

export function clearAuthToken() {
  window.localStorage.removeItem("token");
  document.cookie = "token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT";
}
